import React from 'react';
import { Sidebar } from '../../components/shared/Sidebar';
import { DashboardHeader } from '../../components/shared/DashboardHeader';
import { AnalyticsChart } from '../../components/admin/AnalyticsChart';
import { StatCard } from '../../components/shared/StatCard';
import { MOCK_ANALYTICS } from '../../utils/mockData';
import { motion } from 'framer-motion';
import { TrendingUp, Users, AlertTriangle, DollarSign, Download } from 'lucide-react';
export function Analytics() {
  return <div className="flex min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors pb-16 lg:pb-0" data-id="element-2886">
      <Sidebar data-id="element-2887" />

      <main className="flex-1 lg:ml-[240px] transition-all duration-300" data-id="element-2888">
        <DashboardHeader data-id="element-2889" />

        <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8 py-6 lg:py-8" data-id="element-2890">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-2891">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 lg:mb-8 gap-4" data-id="element-2892">
              <div className="min-w-0" data-id="element-2893">
                <h1 className="text-2xl font-bold text-gray-900 dark:text-white truncate" data-id="element-2894">
                  Platform Analytics
                </h1>
                <p className="mt-1 text-sm text-gray-500 dark:text-gray-400 line-clamp-2" data-id="element-2895">
                  Key metrics and performance indicators.
                </p>
              </div>
              <button className="inline-flex items-center px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg shadow-sm text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors whitespace-nowrap flex-shrink-0" data-id="element-2896">
                <Download className="h-4 w-4 mr-2 flex-shrink-0" data-id="element-2897" />
                Export Report
              </button>
            </div>

            {/* KPI Cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6 mb-6 lg:mb-8" data-id="element-2898">
              <StatCard title="Total Revenue" value="₦45.2M" icon={DollarSign} color="green" trend={{
              value: 12,
              isPositive: true
            }} data-id="element-2899" />
              <StatCard title="Active Tenants" value="1,240" icon={Users} color="blue" trend={{
              value: 5,
              isPositive: true
            }} data-id="element-2900" />
              <StatCard title="Payment Compliance" value="94%" icon={TrendingUp} color="purple" trend={{
              value: 2,
              isPositive: true
            }} data-id="element-2901" />
              <StatCard title="At Risk" value="3.2%" icon={AlertTriangle} color="orange" trend={{
              value: 0.5,
              isPositive: false
            }} data-id="element-2902" />
            </div>

            {/* Charts Grid */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-6 mb-6 lg:mb-8" data-id="element-2903">
              <AnalyticsChart title="Revenue Growth" data={MOCK_ANALYTICS.revenue} type="area" dataKey="amount" xAxisKey="month" color="#10B981" height={280} data-id="element-2904" />

              <AnalyticsChart title="Payment Compliance" data={MOCK_ANALYTICS.paymentCompliance} type="line" dataKey="rate" xAxisKey="month" color="#3B82F6" height={280} data-id="element-2905" />
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-6" data-id="element-2906">
              <div className="lg:col-span-2" data-id="element-2907">
                <AnalyticsChart title="Tenant Retention" data={MOCK_ANALYTICS.tenantRetention} type="bar" dataKey="rate" xAxisKey="month" color="#8B5CF6" height={240} data-id="element-2908" />
              </div>

              <AnalyticsChart title="Risk Distribution" data={MOCK_ANALYTICS.riskDistribution} type="pie" dataKey="value" height={240} data-id="element-2909" />
            </div>
          </motion.div>
        </div>
      </main>
    </div>;
}